// Module
var code = `<!--
<ul>
  <li>
    <header>
      <p class="attributes">
        {{#content}}
        <span>{{.*}}</span>

        {{/content}}
      </p>
    </header>
  </li>
</ul>
-->
`;
// Exports
module.exports = code;